module.exports = {
  fontFamily: {
    heading: 'Poppins, sans-serif', // for H1-H6
    body: 'Roboto, sans-serif', // default for body text
    label: 'Poppins, sans-serif', // for buttons/labels
    code: 'Inconsolata, monospace', // code blocks
    link: 'Roboto, sans-serif', // anchor links
    icon:  'Roboto, sans-serif', // icon font
  },

  fontWeights: {
    headingLight: 300,
    headingRegular: 400,
    headingMedium: 500,
    headingBold: 700,
    bodyLight: 300,
    bodyRegular: 400,
    bodyMedium: 500,
    bodyBold: 700,
    buttonSemiBold: 600,
    labelRegular: 400,
    labelBold: 700,
    codeRegular: 400,
    codeBold: 700,
    iconLight: 300,
    iconRegular: 400,
    iconSolid: 500,
    iconDefault: 300,
  },

  fontSizes: {
    xs: 12,
    sm: 14,
    md: 16,
    lg: 20,
    xl: 24,
    '2xl': 32,
    '3xl': 40,
    '4xl': 48,
    '5xl': 64,
    icon3xl: 360,
    icon2xl: 180,
    iconXl: 48,
    iconLg: 32,
    iconMd: 24,
    iconSm: 16,
    iconXs: 12,
  },

  lineHeights: {
    tight: 1.2,
    snug: 1.3,
    normal: 1.5,
    relaxed: 1.6,
    icon3xl: '360px',
    icon2xl: '180px',
    iconXl: '48px',
    iconLg: '32px',
    iconMd: '24px',
    iconSm: '16px',
    iconXs: '12px',
  },

  letterSpacing: {
    tighter: -0.5,
    none: 0,
    normal: 0.25,
    wide: 0.4,
    wider: 1,
  },

  paragraphSpacing: {
    none: 0,
    sm: 4,
    md: 8,
    lg: 16,
  },
}